module.exports = __webpack_public_path__ + "img/qr-scan-overlay-inline.c02d581f.webp";